import { InjectionToken } from '@angular/core'
import type { ActionReducer, ActionReducerMap } from '@ngrx/store'

import * as fromInteractionContext from '../interaction-context'
import * as fromInteractions from '../interactions'
import * as fromPhotoAccessRequests from '../photo-access-requests'
import * as fromProfiles from '../profiles'
import * as fromSettings from '../settings'
import * as fromUnreadInteractions from '../unread-interactions'

export interface State {
  photoAccessRequests: fromPhotoAccessRequests.State
  settings: fromSettings.State
  [fromInteractionContext.featureKey]: fromInteractionContext.State
  [fromInteractions.featureKey]: fromInteractions.State
  [fromUnreadInteractions.featureKey]: fromUnreadInteractions.State
  [fromProfiles.featureKey]: fromProfiles.State
}

export function getInitialState() {
  return {
    photoAccessRequests: fromPhotoAccessRequests.initialState,
    settings: fromSettings.initialState,
    [fromInteractionContext.featureKey]: fromInteractionContext.initialState,
    [fromInteractions.featureKey]: fromInteractions.initialState,
    [fromUnreadInteractions.featureKey]: fromUnreadInteractions.initialState,
    [fromProfiles.featureKey]: fromProfiles.initialState,
  }
}

export const ROOT_REDUCERS = new InjectionToken<ActionReducerMap<State>>('Root reducers token', {
  factory: () => ({
    photoAccessRequests: fromPhotoAccessRequests.reducer,
    settings: fromSettings.reducer,
    [fromInteractionContext.featureKey]: fromInteractionContext.reducer,
    [fromInteractions.featureKey]: fromInteractions.reducer,
    [fromUnreadInteractions.featureKey]: fromUnreadInteractions.reducer,
    [fromProfiles.featureKey]: fromProfiles.reducer,
  }),
})

function logger(reducer: ActionReducer<State>): ActionReducer<State> {
  return (state, action) => {
    const result = reducer(state, action)
    console.groupCollapsed(action.type)
    console.log('prev state', state)
    console.log('action', action)
    console.log('next state', result)
    console.groupEnd()

    return result
  }
}

export const metaReducers = import.meta.env.NG_APP_CONFIGURATION !== 'production' ? [logger] : []
